export const GET_CLAIMS = "GET_CLAIMS"
export const GET_CLAIM = "GET_CLAIM"
export const GET_CLAIMS_BY_ID = "GET_CLAIMS_BY_ID"
export const DELETE_CLAIM = "DELETE_CLAIM"